<template>
  <div class="userMain">
    <!-- 搜索框 -->
    <SearchBar @search="search" />

    <!-- 表单 -->
    <el-table
      class="table"
      v-loading="listLoading"
      height="750"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="用户名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.nickName) }}
        </template>
      </el-table-column>

      <el-table-column label="内容" align="center">
        <template slot-scope="scope">
          {{ scope.row.message }}
        </template>
      </el-table-column>

      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ statuList[scope.row.status - 1] }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.mobile, scope.row.isShowAllPhone) }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="发送时间" align="center">
        <template slot-scope="scope" v-if="scope.row.sendTime">
          <div>{{ scope.row.sendTime }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="修改时间" align="center">
        <template slot-scope="scope" v-if="scope.row.updateTime">
          <div>{{ scope.row.updateTime }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="editCell(scope.row)"
              type="primary"
              v-if="roleList[path].includes('_Update')"
              >编辑</el-button
            >
          </div>
          <div class="lastBtn">
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="delCell(scope.row.myMsgId)"
              type="danger"
              v-if="roleList[path].includes('_Delete')"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />

    <!-- 编辑表单对话框 -->
    <editForm ref="editForm" @fetchData="fetchData" />
  </div>
</template>

<script>
import { getMyMsgApi, delMyMsgApi } from '@/api/newsApi.js';
const editForm = () => import('./components/editForm'); // 增加表单
import Pagination from '@/components/Pagination'; // 分页
import SearchBar from './components/searchBar'; // 搜索框
import { mapGetters } from 'vuex';
import { getToken } from '@/utils/token.js';
import { decrypt } from '@/utils/encryp';

export default {
  name: 'Message',
  components: {
    editForm,
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: [],
      listLoading: false,
      editShow: true,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      path: '',
      statuList: ['编辑中', '已发布', '已删除'],
    };
  },
  created() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.userId = getToken('userInfo').userId;
  },

  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        // status ->  1.编辑中， 2.已发布， 3.已删除
        this.listLoading = true;
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        let res = await getMyMsgApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...this.fromSearchObj,
          areaId,
        });
        if (res.code !== 200) return;
        let { pageSize, pageIndex, dataList = [], totalCount } = res.data;
        this.list = dataList || [];
        this.listLoading = false;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.totalCount = totalCount;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },

    // 编辑
    editCell(row) {
      this.$refs.editForm.editForm = {
        // 编辑表单
        message: row.message,
        status: row.status,
        userId: row.userId,
        myMsgId: row.myMsgId,
      };
      this.$refs.editForm.statuName = this.statuList[row.status - 1];
      this.$refs.editForm.dialogFormVisible = true;
    },

    // 删除
    async delCell(myMsgId) {
      try {
        let res = await delMyMsgApi(myMsgId);
        if (res.code !== 200) return;
        this.$message.success('删除成功！');
        // 判断是否当前页的最后一条数据
        let bol =
          this.totalCount - this.pageSize * this.pageIndex === 1 ? true : false;
        // 不是第一页就-1
        if (bol && this.pageIndex > 1) {
          this.$refs.Pagination.pageIndex--;
        } else {
          this.fetchData();
        }
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  position: relative;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.lastBtn {
  margin-top: 10px;
}
</style>
